import { memo, useMemo } from 'react';

const style = require('./index.css');

interface ISeoTextProps {
  text: string;
}

/**
 * Отдельный мемоизированный компонент: React 19 сравнивает пропсы DOM-узла по ссылке и на каждый
 * ререндер выдачи заново присваивал бы innerHTML этому блоку.
 */
export const SeoText = memo(function SeoText({ text }: ISeoTextProps) {
  const markup = useMemo(() => ({ __html: text }), [text]);

  // eslint-disable-next-line react/no-danger
  return <div className={style['seoText']} dangerouslySetInnerHTML={markup} />;
});
